// Clerk user IDs are used only as local dedup keys, never as Ads parameters.
const SIGNUP_WINDOW_MS = 5 * 60 * 1000;
const SENT_PREFIX = "gads_sent:";
type StorageAccess = () => {
  getItem: (key: string) => string | null;
  setItem: (key: string, value: string) => void;
};

export function signupAlreadySent(
  key: string, persistent: StorageAccess, session: StorageAccess,
): boolean {
  for (const access of [persistent, session]) {
    try {
      if (access().getItem(`${SENT_PREFIX}${key}`) === "1") {
        // Promote legacy session-only keys into persistent storage when available.
        markSignupSent(key, persistent, session);
        return true;
      }
    } catch { /* Fall back when browser storage is unavailable. */ }
  }
  return false;
}

export function markSignupSent(
  key: string, persistent: StorageAccess, session: StorageAccess,
): void {
  for (const access of [persistent, session]) {
    try { access().setItem(`${SENT_PREFIX}${key}`, "1"); } catch { /* Best effort. */ }
  }
}

interface SignupSink {
  now: number;
  tagId: string;
  sendTo?: string;
  alreadySent: (key: string) => boolean;
  markSent: (key: string) => void;
  emit: (name: string, params: Record<string, unknown>) => void;
}

/** A loaded authenticated Clerk user with a recent creation timestamp. */
export function reportAccountSignup(
  account: { userId: string; createdAt: number }, sink: SignupSink,
): void {
  const age = sink.now - account.createdAt;
  if (!account.userId || !Number.isFinite(account.createdAt) || account.createdAt <= 0 ||
      age < 0 || age > SIGNUP_WINDOW_MS) return;
  const key = `signup:${account.userId}`;
  if (sink.alreadySent(key)) return;
  sink.emit("sign_up", { method: "clerk", send_to: sink.tagId });
  const sendTo = sink.sendTo?.trim();
  if (sendTo) sink.emit("conversion", { send_to: sendTo, value: 0, currency: "USD" });
  sink.markSent(key);
}
